<div class="popup-global-layout width-950">
  <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
  <div class="global-title">{{ 'claims.edit.whatHappened.documents.documentUploadTitle' | translate }}</div>

  <upsc-collapsible-panel-light [title]="'claimsDetail.upload.documentGuideHeader1' | translate" [isCollapsed]="true">
    <div innerHTML="{{'claimsDetail.upload.documentGuideSubHeader' | translate}}" class="subheading"></div>
    <div innerHTML="{{'claimsDetail.upload.documentGuideDesSSP' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
    <div innerHTML="{{'claimsDetail.upload.documentGuideDesTUPSS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
  </upsc-collapsible-panel-light>
  <upsc-collapsible-panel-light [title]="'claimsDetail.upload.documentGuideHeader2' | translate" [isCollapsed]="true">
    <div innerHTML="{{'claimsDetail.upload.documentSubHeader13' | translate}}" class="subheading"></div>
        <div innerHTML="{{'claimsDetail.upload.documentSubHeader13Des' | translate}}" class="description"></div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader14' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader14Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader14TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
     <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader15' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader15Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader15TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
     <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader16' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader16Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader16TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
     <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader17' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader17Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader17TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
      </upsc-collapsible-panel-light>
  <upsc-collapsible-panel-light [title]="'claimsDetail.upload.documentGuideHeader3' | translate" [isCollapsed]="true">
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader1' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader1Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader1TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
    <div class="sub-content" *ngIf="portalType==='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader2' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader2TUPPS' | translate}}" class="description"></div>
    </div>
    <div class="sub-content" *ngIf="portalType !=='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader3' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader3Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content" *ngIf="portalType !=='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader4' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader4Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content" *ngIf="portalType !=='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader5' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader5Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content" *ngIf="portalType !=='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader6' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader6Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content" *ngIf="portalType !=='tupss'">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader7' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader7Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader8' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader8Des' | translate}}" class="description"></div>
    </div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader9' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader9Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader9TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader10' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader10Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader10TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader11' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader11Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader11TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
    <div class="sub-content">
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader12' | translate}}" class="subheading"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader12Des' | translate}}" class="description" *ngIf="portalType!=='tupss'"></div>
      <div innerHTML="{{'claimsDetail.upload.documentSubHeader12TUPPS' | translate}}" class="description" *ngIf="portalType==='tupss'"></div>
    </div>
  </upsc-collapsible-panel-light>


</div>